import { initFaro, trackView } from '@/lib/telemetry/faro';

void initFaro();

export function onRouterTransitionStart(url: string) {
  trackView(url);
}
